"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = exports.BACKGROUND = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("./style.scss");
var BACKGROUND;
(function (BACKGROUND) {
    BACKGROUND["WHITE"] = "WHITE";
    BACKGROUND["BLACK"] = "BLACK";
})(BACKGROUND || (exports.BACKGROUND = BACKGROUND = {}));
const Card = ({ children, className = null, background = BACKGROUND.WHITE, width = '100%', fullHeight = false, noScroll = false, }) => {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('card', background.toLowerCase(), className), style: { width, height: fullHeight ? '100%' : 'auto', flex: 1, overflow: noScroll ? 'unset' : undefined } }, children));
};
exports.Card = Card;
Card.BACKGROUND = BACKGROUND;
